import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Auth, API, Storage, Amplify} from 'aws-amplify';
import ConfigurationTab from './ConfigurationTab'; 
import TransformationsTab from './TransformationsTab';
import PreviousBreaksTab from './PreviousBreaksTab'; 
import FileCheckDisplay from './FileCheckDisplay'; 
import RecentResultsTable from './RecentResultsTable'; 
import StitchFunctionTab from './StitchFunctionTab';
import AccessControlTab from './AccessControlTab';
import './ReconciliationPage.css';
import FilesTab from './FilesTab';
import SftpTab from './SftpTab';
import AuditTrailTab from './AuditTrailTab';
import Header from './Header'; 
import { TfiReload } from 'react-icons/tfi';
import ReconciliationMetricsDisplay from './ReconciliationMetricsDisplay.js';  
import './ReconciliationMetricsDisplay.css'

function ReconciliationPage() {
  const { id } = useParams();

  // State variables
  const [allResultsLambdaResponses, setAllResultsLambdaResponses] = useState({});
  const [mostRecentLambdaResponses, setMostRecentLambdaResponses] = useState({});
  const [allTimestamps, setAllTimestamps] = useState({});
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAllResults, setShowAllResults] = useState({});
  const [allResultsShowTable, setAllResultsShowTable] = useState({});
  const [selectedTimestamp, setSelectedTimestamp] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [filesFetched, setFilesFetched] = useState(false);
  const [resultsFetched, setResultsFetched] = useState(false);
  const [isTimestampDropdownVisible, setIsTimestampDropdownVisible] = useState(false);
  const [sortedBreaks, setSortedBreaks] = useState([]);
  const [userRole, setUserRole] = useState(null);
  const [userEmail, setUserEmail] = useState(null);

  // State variables for editing
  
  const [mostRecentTimestamp, setMostRecentTimestamp] = useState(null);
  const [recentResult, setRecentResult] = useState({});
  const [currentTab, setCurrentTab] = useState('Current Breaks'); // This will set 'Current Breaks' as the default tab
  const [isConfigDropdownVisible, setIsConfigDropdownVisible] = useState(false);

  const fetchConfigData = async (title) => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      const userEmail = user.attributes.email;
      setUserEmail(userEmail)

      const organization = userEmail.split('@')[1].split('.')[0];
      const requestBody = { title, organization };

      const response = await API.post('fetchConfigAPI', '/fetchconfig', { body: requestBody });
      console.log("response response")
      console.log(response)

      if (response.item) {
        setConfigData(response.item);

        // Find user's role in configData.users
        const userEntry = Object.values(response.item.users).find((user) => user.email === userEmail);
        setUserRole(userEntry ? userEntry.role : 'No Access'); 
      }
      console.log("Current User Role")
      console.log(userRole)
    } catch (err) {
      console.error("Error fetching config data:", err);
    }
  };

  const handleConfigurationClick = () => {
    setIsConfigDropdownVisible(!isConfigDropdownVisible);
  };

  const handleTimestampSelect = (timestamp) => {
    console.log("handleTimestampSelect - Selected timestamp:", timestamp); // Log selected timestamp
    setSelectedTimestamp(timestamp);
    setIsTimestampDropdownVisible(false); // Close dropdown after selection
    
    fetchAndSetRecentResult(timestamp); 
  };
  
  
  
  




  const MAX_RETRIES = 5;
const RETRY_DELAY = 5000; // Delay in milliseconds

const fetchRecentResult = async (title, timestamp = null) => {
  for (let attempt = 1; attempt <= MAX_RETRIES; attempt++) {
    try {
      const currentUser = await Auth.currentAuthenticatedUser();
      const userOrganization = currentUser.attributes['email'].split('@')[1].split('.')[0];

      console.log("fetchRecentResult - Sending timestamp:", timestamp); // Log the timestamp being sent to API

      const requestBody = {
        title: title,
        organization: userOrganization,
        timestamp: timestamp,
        userRole: userRole, // Send timestamp if provided
      };

      const apiData = await API.post('LatestResults', `/newestres`, { body: requestBody });

      setIsLoading(false); // Stop loading after successfully fetching data
      console.log("DATA Response:", apiData); // Log API response
      return apiData; // Return fetched data

    } catch (error) {
      if (attempt === MAX_RETRIES) {
        setIsLoading(false); // Ensure loading state is updated even on failure
        throw error;
      }

      await new Promise(resolve => setTimeout(resolve, RETRY_DELAY)); // Wait before retrying
    }
  }
};



const fetchAndSetRecentResult = async (timestamp = selectedTimestamp) => {
  setResultsFetched(false);

  if (!id) return;

  console.log("fetchAndSetRecentResult - Using timestamp:", timestamp); // Log the timestamp being used

  try {
    const data = await fetchRecentResult(id, timestamp); // Pass the timestamp properly
    setRecentResult(data);
    console.log("data in this")
    setResultsFetched(true);
  } catch (error) {
    console.error("Error fetching recent result:", error);
  } finally {
    setIsLoading(false);
  }
};




useEffect(() => {
  const fetchInitialData = async () => {
    console.log("Component rendering", new Date().toISOString());

    if (id) {
      try {
        await fetchConfigData(id);
        await fetchAndSetRecentResult(); // Fetch latest results on page load
        handleShowAllResults(id);
      } catch (error) {
        console.error("Error loading initial data:", error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  fetchInitialData();
}, [id]);




// Fetching all Previous Results

    // Function to fetch data from DynamoDB
    const fetchDataFromDynamoDB = async (title, timestamp, type = "allResults") => {
      try {
      
        const user = await Auth.currentAuthenticatedUser();
        const organization = user.attributes['email'].split('@')[1].split('.')[0];
        
        const requestBody = {
          title: title,
          timestamp: timestamp,
          organization: organization
        };
    
       
        const response = await API.post('fetchResultsAPI', `/fetchres`, { body: requestBody });
        
    
        if (response.data && Array.isArray(response.data)) {
          const parsedData = response.data.map(item => ({
            ...item,
            timestamp: item.timestamp || '',
            break_counts: JSON.parse(item.break_counts),
            merged_breaks: JSON.parse(item.merged_breaks),
            metrics: JSON.parse(item.metrics),
            set1_breaks: JSON.parse(item.set1_breaks),
            set2_breaks: JSON.parse(item.set2_breaks),
          }));
    
          if (type === "allResults") {
            setAllResultsLambdaResponses(prevState => ({ ...prevState, [title]: parsedData }));
          } else {
            setMostRecentLambdaResponses(prevState => ({ ...prevState, [title]: parsedData }));
          }
          
        } else {
        
        }
      } catch (err) {
       
      }
      
    };
    
    const sendDataToLambda = async (title) => {
      // Prevent execution if the user is not authorized
      if (!['Reconciler', 'Editor', 'Admin'].includes(userRole)) {
        alert('You do not have permission to run reconciliation.');
        return;
      }
    
      setIsSending(true);
      try {
        const user = await Auth.currentAuthenticatedUser();
        const organization = user.attributes['email'].split('@')[1].split('.')[0];
    
        // API call to start the reconciliation process
        const response = await API.post('reconcile', '/reconcile', {
          body: {
            title: title,
            organization: organization,
            user: user.attributes['email']
          },
        });
    
        if (response) {
          // Fetch the updated recent result data after receiving the response
          await fetchAndSetRecentResult();
        }
    
        // Update the UI to show that the reconciliation is complete
        setIsSending(false);
        setShowAllResults((prevState) => ({
          ...prevState,
          [title]: true, // Ensure this stays true after results are fetched
        }));
      } catch (err) {
        // Handle errors
        if (err.response && err.response.status === 504) {
          alert('Reconciling files, this will take a few minutes, please reload the page');
        } else {
          alert('Configuration error, please update configuration');
        }
        setIsSending(false);
      }
    };
    
    
  
  
    
    const fetchAllTimestampsForTitle = async (title) => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const organization = user.attributes['email'].split('@')[1].split('.')[0];
    
        const requestBody = {
          title: title,
          organization: organization
        };
    
        const response = await API.post('fetchtime', `/fetchtime`, {
          body: requestBody
        });
    
        console.log("TIMES RESP");

        console.log(user);
    
        // Sort timestamps in descending order
        const sortedTimestamps = response.map(item => item.timestamp).sort((a, b) => new Date(b) - new Date(a));
        console.log("Sorted");
        console.log(sortedTimestamps);
    
        // Sort total_breaks in the same order as sorted timestamps
        const sortedBreaksList = response
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))
          .map(item => item.total_breaks);
    
        console.log(sortedBreaksList);
    
        // Store sorted timestamps and breaks in state
        setSortedBreaks(sortedBreaksList);
        setAllTimestamps(prevState => ({ ...prevState, [title]: sortedTimestamps }));
    
        if (!selectedTimestamp) {
          setSelectedTimestamp(sortedTimestamps[0]);
        }
    
        if (sortedTimestamps.length > 0) {
          setMostRecentTimestamp(sortedTimestamps[0]);
        }
      } catch (err) {
        console.error("Error fetching timestamps:", err);
      }
    };
    
    
    
    
    
  
  
    // Function to handle showing all results
    const handleShowAllResults = (title) => {
      
      setShowAllResults(prevState => ({
        ...prevState,
        [title]: true,
      }));
      fetchAllTimestampsForTitle(title);
    };
  

  







    const [allExcelUrls, setAllExcelUrls] = useState({});
    useEffect(() => {
      handleShowAllResults(id);
      if (selectedTimestamp) {
          setTimeout(() => {
              fetchDataFromDynamoDB(id, selectedTimestamp);
              getExcelDownloadUrl(selectedTimestamp).then(url => {
                  setAllExcelUrls(prev => ({ ...prev, [selectedTimestamp]: url }));
              });
          }, 1000);
      }
      fetchConfigData(id);
  }, [id, selectedTimestamp]);
  

   
    const getExcelDownloadUrl = async (timestamp) => {
      const fileKey = `reconciliation_results_${timestamp}.xlsx`;
      try {
        const signedUrl = await Storage.get(fileKey, { expires: 300 });  // URL will be valid for 5 minutes
        return signedUrl;
      } catch (error) {

        return null;
      }
    }

    // Utility function to format timestamp
const formatTimestamp = (timestamp) => {
  if (!timestamp) return '';

  const date = new Date(timestamp);

  // Format date and time
  return new Intl.DateTimeFormat('en-US', {
    month: 'short',  // Jan, Feb, Mar...
    day: '2-digit',  // 21, 01, etc.
    hour: '2-digit', // 1, 2, 3...
    minute: '2-digit', // 01, 02, 03...
    hour12: true, // Ensure AM/PM format
    timeZoneName: 'short' // EST, PST, etc.
  }).format(date);
};
const sortedTimestamps = allTimestamps[id] ? [...allTimestamps[id]].sort((a, b) => new Date(b) - new Date(a)) : [];


    




    useEffect(() => {
      if (mostRecentTimestamp) {
        fetchDataFromDynamoDB(id, mostRecentTimestamp);
      }
    }, [mostRecentTimestamp, id]);
    


  const [excelUrl, setExcelUrl] = useState(null);


  useEffect(() => {
    // Only fetch selected timestamp data if it's set, preventing duplicate calls
    if (selectedTimestamp) {
      fetchDataFromDynamoDB(id, selectedTimestamp);
      getExcelDownloadUrl(selectedTimestamp).then(url => setExcelUrl(url));
    }
  }, [selectedTimestamp, id]);

const [areFilesPresent, setAreFilesPresent] = useState(false);

// Define the handleFileStatusChange function
const handleFileStatusChange = (fileStatus) => {
    setAreFilesPresent(fileStatus);
};

const switchToFilesTab = () => {
  setCurrentTab('Files');
};





if (isLoading || !resultsFetched) {
  return (
    <div className="loading">
      <div className="ai-animation">
        <div className="circle circle-1"></div>
        <div className="circle circle-2"></div>
      </div>
      Loading Results...
    </div>
  );
}

if (!['Viewer', 'Reconciler', 'Editor', 'Admin'].includes(userRole)) {
  return (
    
    <div className="not-authorized-container">
      <Header />
      <h2 className="not-authorized-heading">Access Denied</h2>
      <p className="not-authorized-message">You do not have permission to view this page.</p>
    </div>
  );
}



if (Object.keys(recentResult).filter(key => key !== "audit_trail").length === 0 && !isLoading) {

  return (
    <div className="recon-parent-container">
      <Header />
      <div className="recon-header">
      <h2 className="config-name">Configuration: {configData.displayTitle}</h2>

      <div className="init-tab-container">
      <button onClick={() => setCurrentTab('Current Breaks')} className={`recon-tab ${currentTab === 'Current Breaks' ? 'recon-tab-active' : ''}`}>Current Breaks</button>
     
      


      <div className="config-dropdown">
          <button 
  onClick={handleConfigurationClick} 
  className={`recon-tab ${currentTab === 'Configuration' ? 'recon-tab-active' : ''}`} 
  disabled={!['Reconciler', 'Editor', 'Admin'].includes(userRole)}
>
  Configuration ⯆
</button>

            {isConfigDropdownVisible && (


<div className="config-dropdown-menu">
  {/* Data Settings, Stitch Data, SFTP, Transformations (Only for Editor & Admin) */}
  {(userRole === 'Editor' || userRole === 'Admin') && (
    <>
      <button onClick={() => { setCurrentTab('Configuration'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Configuration' ? 'recon-tab-active' : ''}`}>
        Data Settings
      </button>
      <button onClick={() => { setCurrentTab('Transformations'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Transformations' ? 'recon-tab-active' : ''}`}>
        Transformations
      </button>
      <button onClick={() => { setCurrentTab('Stitch Data'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Stitch Data' ? 'recon-tab-active' : ''}`}>
        Stitch Data
      </button>
      <button onClick={() => { setCurrentTab('Sftp'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Sftp' ? 'recon-tab-active' : ''}`}>
        SFTP
      </button>
    </>
  )}

  {/* File Upload, Audit Trail (Only for Reconciler, Editor, Admin) */}
  {(userRole === 'Reconciler' || userRole === 'Editor' || userRole === 'Admin') && (
    <>
      <button onClick={() => { setCurrentTab('Files'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Files' ? 'recon-tab-active' : ''}`}>
        File Upload
      </button>
      <button onClick={() => { setCurrentTab('Audit Trail'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Audit Trail' ? 'recon-tab-active' : ''}`}>
        Audit Trail
      </button>
    </>
  )}

  {/* Access Control (Only for Admin) */}
  {userRole === 'Admin' && (
    <button onClick={() => { setCurrentTab('Access Control'); setIsConfigDropdownVisible(false); }} 
      className={`config-dropdown-item ${currentTab === 'Access Control' ? 'recon-tab-active' : ''}`}>
      Access Control
    </button>
  )}
</div>
            )}
          </div>
      </div>
    </div>


    

{/* Current Breaks Tab */}
{currentTab === 'Current Breaks' && (
  <div className="recon-current-breaks">
    <div className="no-results-message">
      {!areFilesPresent ? (
        <>
          <h2>Files Are Missing</h2>
          <h3>Please ensure all required files are uploaded before running reconciliation.</h3>
          <button onClick={() => setCurrentTab('Files')} className="send-button">
            Upload Files
          </button>
          <button onClick={() => setCurrentTab('Configuration')} className="send-button">
            View File Config
          </button>
          <button onClick={() => window.location.reload()} className="page-refresh-button">
            <TfiReload size={24} />
          </button>
        </>
      ) : (
        <>
          <h2>No Reconciliation Results for this Configuration</h2>
          <h3>Please Run Reconciliation</h3>
          <button onClick={() => sendDataToLambda(id)} disabled={isSending} className="send-button">
            {isSending ? 'Processing...' : 'Run Reconciliation'}
          </button>
          <button onClick={() => window.location.reload()} className="page-refresh-button">
            <TfiReload size={24} />
          </button>
        </>
      )}
    </div>
    <FileCheckDisplay
      configData={configData}
      onFileStatusChange={handleFileStatusChange}
      setIsLoading={setIsLoading} // Pass setIsLoading as a prop
    />
  </div>
)}



{/* Configuration Tab */}
{currentTab === 'Configuration' && (
  <ConfigurationTab 
    configData={configData} 
    title={id} 
    userRole={userRole} 
    onConfigEdited={(newConfig) => { /* Handle the updated config if needed */ }} 
  />
)}


  {/* Transformations Tab */}
  {currentTab === 'Transformations' && (
          <TransformationsTab
            configData={configData}
          
          />
        )}

{currentTab === 'Stitch Data' && (
  <StitchFunctionTab configData={configData} />
)}

 {/* Files Tab */}
 {currentTab === 'Files' && (
    <FilesTab 
        configData={configData} 
        title={id} 
        filename1={configData?.filename1} 
        filename2={configData?.filename2} 
    />
 )}

      {/* Sftp Tab */}
      {currentTab === 'Sftp' && (
        <SftpTab configData={configData} title={id} />
      )}


      {/* Sftp Tab */}
      {currentTab === 'Audit Trail' && (
        <AuditTrailTab configData={configData} title={id} data={recentResult}/>
      )}

{currentTab === 'Access Control' && userRole === 'Admin' && (
  <AccessControlTab 
    configData={configData} 
    title={id} 
    users={configData.users} 
    userRole={userRole} 
    userEmail={userEmail} 
  />
)}







    </div>
  );
} else {
  

  return (
    <div className="recon-parent-container">
      <Header />
  
      {/* Flex container for title, tabs (always centered), and timestamp */}
      <div className="recon-header-container">
        <h1 className="config-name left-item">{configData.displayTitle}</h1>
  
        <div className="recon-tab-container">
          <button onClick={() => setCurrentTab('Current Breaks')} className={`recon-tab ${currentTab === 'Current Breaks' ? 'recon-tab-active' : ''}`}>Current Breaks</button>
  
          <div className="config-dropdown">
          <button 
  onClick={handleConfigurationClick} 
  className={`recon-tab ${currentTab === 'Configuration' ? 'recon-tab-active' : ''}`} 
  disabled={!['Reconciler', 'Editor', 'Admin'].includes(userRole)}
>
  Configuration ⯆
</button>

            {isConfigDropdownVisible && (


<div className="config-dropdown-menu">
  {/* Data Settings, Stitch Data, SFTP, Transformations (Only for Editor & Admin) */}
  {(userRole === 'Editor' || userRole === 'Admin') && (
    <>
      <button onClick={() => { setCurrentTab('Configuration'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Configuration' ? 'recon-tab-active' : ''}`}>
        Data Settings
      </button>
      <button onClick={() => { setCurrentTab('Transformations'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Transformations' ? 'recon-tab-active' : ''}`}>
        Transformations
      </button>
      <button onClick={() => { setCurrentTab('Stitch Data'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Stitch Data' ? 'recon-tab-active' : ''}`}>
        Stitch Data
      </button>
      <button onClick={() => { setCurrentTab('Sftp'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Sftp' ? 'recon-tab-active' : ''}`}>
        SFTP
      </button>
    </>
  )}

  {/* File Upload, Audit Trail (Only for Reconciler, Editor, Admin) */}
  {(userRole === 'Reconciler' || userRole === 'Editor' || userRole === 'Admin') && (
    <>
      <button onClick={() => { setCurrentTab('Files'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Files' ? 'recon-tab-active' : ''}`}>
        File Upload
      </button>
      <button onClick={() => { setCurrentTab('Audit Trail'); setIsConfigDropdownVisible(false); }} 
        className={`config-dropdown-item ${currentTab === 'Audit Trail' ? 'recon-tab-active' : ''}`}>
        Audit Trail
      </button>
    </>
  )}

  {/* Access Control (Only for Admin) */}
  {userRole === 'Admin' && (
    <button onClick={() => { setCurrentTab('Access Control'); setIsConfigDropdownVisible(false); }} 
      className={`config-dropdown-item ${currentTab === 'Access Control' ? 'recon-tab-active' : ''}`}>
      Access Control
    </button>
  )}
</div>
            )}
          </div>




        </div>


        <div className="timestamp-dropdown">
  <button className="timestamp-button" onClick={() => setIsTimestampDropdownVisible(!isTimestampDropdownVisible)}>
    {selectedTimestamp ? formatTimestamp(selectedTimestamp) : "Select Timestamp"} ⯆
  </button>

  {isTimestampDropdownVisible && sortedTimestamps.length > 0 && (
    <div className="timestamp-dropdown-menu">
      {sortedTimestamps.map((timestamp, index) => {
        // Ensure timestamp is valid before processing
        if (!timestamp || isNaN(new Date(timestamp).getTime())) {
          console.error(`Invalid dropdown timestamp detected: ${timestamp}`);
          return null; // Skip invalid timestamps
        }

        // Use sortedBreaks array to get the correct total_breaks
        const totalBreaks = sortedBreaks[index] ?? 0;

        console.log(`Dropdown Timestamp: ${timestamp}`);
        console.log(`Assigned Total Breaks: ${totalBreaks}`);

        return (
          <button
            key={index}
            onClick={() => handleTimestampSelect(timestamp)}
            className={`timestamp-dropdown-item ${selectedTimestamp === timestamp ? 'selected-timestamp' : ''}`}
          >
            {formatTimestamp(timestamp)}

            {/* Red circle if totalBreaks > 0, Green circle if 0 */}
            <span className={`break-indicator ${totalBreaks > 0 ? 'red-circle' : 'green-circle'}`}>
              {totalBreaks > 0 ? totalBreaks : ""}
            </span>
          </button>
        );
      })}
    </div>
  )}
</div>









      </div>
  
  

  



  {isLoading && (
    <div className="loading">
        <div className="ai-animation">
            {/* You can add more elements here for complex animations */}
        </div>
        Loading AI Analysis...
    </div>
)}




        {/* Current Breaks Tab */}
{currentTab === 'Current Breaks' && (
<div className="recon-current-breaks">
{/* Metrics Display */}
<ReconciliationMetricsDisplay
  recentResult={recentResult}
  configData={configData}
  filename1={configData?.filename1}
  filename2={configData?.filename2}
/>


{recentResult && (
          <div className="recent-results">          

<RecentResultsTable 
  data={recentResult}
  isSending={isSending}
  onSendToLambda={() => sendDataToLambda(id)}
  excelUrl={excelUrl}
  configData={configData}
  switchToFilesTab={switchToFilesTab}
  userRole={userRole} 
/>
            </div>
        )}
    </div>
)}

  
 
  





{/* Configuration Tab */}
{currentTab === 'Configuration' && (
  <ConfigurationTab 
    configData={configData} 
    title={id} 
    userRole={userRole} 
    onConfigEdited={(newConfig) => { /* Handle the updated config if needed */ }} 
  />
)}


  {/* Transformations Tab */}
  {currentTab === 'Transformations' && (
          <TransformationsTab
            configData={configData}
          
          />
        )}

{currentTab === 'Stitch Data' && (
  <StitchFunctionTab configData={configData} />
)}

 {/* Files Tab */}
 {currentTab === 'Files' && (
    <FilesTab 
        configData={configData} 
        title={id} 
        filename1={configData?.filename1} 
        filename2={configData?.filename2} 
    />
 )}

      {/* Sftp Tab */}
      {currentTab === 'Sftp' && (
        <SftpTab configData={configData} title={id} />
      )}


      {/* Sftp Tab */}
      {currentTab === 'Audit Trail' && (
        <AuditTrailTab configData={configData} title={id} data={recentResult}/>
      )}

{currentTab === 'Access Control' && userRole === 'Admin' && (
  <AccessControlTab 
    configData={configData} 
    title={id} 
    users={configData.users} 
    userRole={userRole} 
    userEmail={userEmail} 
  />
)}







  </div>
);


}


}

export default ReconciliationPage;




